export default "__VITE_ASSET__B09tqW0w__"